import React, { useRef, useEffect } from "react";

const BLOBS = [
  {
    radius: 600,
    color: "rgba(255, 255, 255, 0.06)",
    xAmp: 0.25,
    yAmp: 0.2,
    xPeriod: 20,
    yPeriod: 25,
    xPhase: 0,
    yPhase: 0,
  },
  {
    radius: 500,
    color: "rgba(255, 255, 255, 0.04)",
    xAmp: 0.2,
    yAmp: 0.28,
    xPeriod: 28,
    yPeriod: 18,
    xPhase: 2,
    yPhase: 1,
  },
  {
    radius: 450,
    color: "rgba(255, 255, 255, 0.05)",
    xAmp: 0.28,
    yAmp: 0.15,
    xPeriod: 22,
    yPeriod: 32,
    xPhase: 4,
    yPhase: 3,
  },
  {
    radius: 550,
    color: "rgba(255, 255, 255, 0.03)",
    xAmp: 0.15,
    yAmp: 0.22,
    xPeriod: 35,
    yPeriod: 20,
    xPhase: 1,
    yPhase: 5,
  },
];

function getBlobPosition(blob, t, w, h) {
  const cx = w * 0.5 + Math.sin(t / blob.xPeriod + blob.xPhase) * w * blob.xAmp;
  const cy = h * 0.5 + Math.cos(t / blob.yPeriod + blob.yPhase) * h * blob.yAmp;
  return { cx, cy };
}

const SpaceBackground = () => {
  const canvasRef = useRef(null);
  const animRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const animate = (timestamp) => {
      if (!startTimeRef.current) startTimeRef.current = timestamp;
      const elapsed = (timestamp - startTimeRef.current) / 1000;

      const w = canvas.width;
      const h = canvas.height;

      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";

      for (const blob of BLOBS) {
        const { cx, cy } = getBlobPosition(blob, elapsed, w, h);

        const gradient = ctx.createRadialGradient(
          cx,
          cy,
          0,
          cx,
          cy,
          blob.radius,
        );
        gradient.addColorStop(0, blob.color);
        gradient.addColorStop(1, "rgba(0, 0, 0, 0)");

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(cx, cy, blob.radius, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.globalCompositeOperation = "source-over";
      animRef.current = requestAnimationFrame(animate);
    };

    animRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animRef.current);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        pointerEvents: "none",
      }}
    />
  );
};

export default SpaceBackground;
